import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ReinviteSvg',
  props: {
    width: { default: 13 },
    height: { default: 14 },
    stroke: { default: 'currentColor' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M5.6875 7V6.1875C5.6875 5.32555 6.02991 4.4989 6.6394 3.8894C7.2489 3.27991 8.07555 2.9375 8.9375 2.9375H10.9688M9.29933 8.625C9.01747 9.11867 8.61008 9.52903 8.11845 9.81445C7.62683 10.0999 7.06847 10.2502 6.5 10.2502C5.93153 10.2502 5.37317 10.0999 4.88155 9.81445C4.38992 9.52903 3.98253 9.11867 3.70067 8.625H1.625C1.40951 8.625 1.20285 8.7106 1.05048 8.86298C0.898102 9.01535 0.8125 9.22201 0.8125 9.4375V11.875C0.8125 12.0905 0.898102 12.2972 1.05048 12.4495C1.20285 12.6019 1.40951 12.6875 1.625 12.6875H11.375C11.5905 12.6875 11.7972 12.6019 11.9495 12.4495C12.1019 12.2972 12.1875 12.0905 12.1875 11.875V9.4375C12.1875 9.22201 12.1019 9.01535 11.9495 8.86298C11.7972 8.7106 11.5905 8.625 11.375 8.625H9.29933Z",
      stroke: __props.stroke,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M8.9375 1.3125L10.9688 2.9375L8.9375 4.5625",
      stroke: __props.stroke,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_3)
  ], 16, _hoisted_1))
}
}

})